module.exports = __webpack_public_path__ + "img/icon-warning.d108cc3f.svg";